import { useLocation } from "react-router-dom";

/**
 * A simple ancillary hook to get the app name from the url in order
 * to use it in usOperatingContext as a key to store and persist
 * the context selected by each app in particular.
 *
 * @returns appName: string
 */
export const useAppName = () => {
  const location = useLocation();

  // The app name is the first part of the url pathname. Ex: /home/my-account -> home
  const appName = location.pathname.split("/")[1];

  // eslint-disable-next-line @typescript-eslint/prefer-nullish-coalescing
  return appName || "home";
};
